export default __webpack_public_path__ + "static/media/skyship15.404ba1ca.png";